import { AssetType, usePreload } from "./usePreload";

const useImages = (imageUrls: string[]) =>
  usePreload(imageUrls.map((url) => ({ type: AssetType.Image, url })));

export default useImages;
